import auth from 'api/auth';
import UploadingComponent from 'components/UploadingComponent/UploadingComponent';
import { functionCollectBrowserData } from 'helpers/browserData/functionCollectBrowserData';
import { saveTokensAfterAuthentication } from 'helpers/cookies';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

export default function TFAuth() {
  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (params.password) {
      fetchAuth(params.password, '');
    }
  }, [params]);

  const fetchAuth = async (auth_password: string, email: string) => {
    try {
      const browserData = await functionCollectBrowserData();
      const formData = new FormData();
      formData.append('auth_password', auth_password);
      formData.append('email', email);
      formData.append('browser_data', JSON.stringify(browserData) || '');
      const response = await auth.verifyAuth(
        { auth_password, email, browser_data: JSON.stringify(browserData) || '' },
        formData
      );

      saveTokensAfterAuthentication(response.data); 

      // const form_data = new FormData();
      // form_data.append('browser_data', JSON.stringify(browserData));
      navigate('/');

      // await api.sendBrowserFingerprint(form_data);
    } catch (err) {}
  };

  return <UploadingComponent />;
}
